import ICON_CHECK_OFF_LIGHT from '../../../../public/static/v4/myPage/icon-check-off-light.svg';
import ICON_CHECK_OFF from '../../../../public/static/v4/myPage/icon-check-off.svg';
import ICON_CHECK_ON_LIGHT from '../../../../public/static/v4/myPage/icon-check-on-light.svg';
import ICON_CHECK_ON from '../../../../public/static/v4/myPage/icon-check-on.svg';
import useTheme from '../../../common/hook/useTheme';

interface IProps {
  isSelected: boolean;
}

export default function ToggleV4({isSelected}: IProps) {
  const {theme} = useTheme();
  const iconMap = ICON_MAP[theme];

  return (
    <img
      src={isSelected ? iconMap.on : iconMap.off}
      className="w-20 h-20"
      alt=""
    />
  );
}

const ICON_MAP = {
  light: {
    on: ICON_CHECK_ON_LIGHT,
    off: ICON_CHECK_OFF_LIGHT,
  },
  dark: {
    on: ICON_CHECK_ON,
    off: ICON_CHECK_OFF,
  },
};
